import React from 'react';
import {
    ButtonGroup,
    CardBody,
    CardTitle,
    CardFooter
} from 'reactstrap';
import { Weekdays } from '../Common';
import {
    faEllipsisV
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';

export default class BrokerCard extends React.Component {

    render() {
        const {
            broker,
            provided,
            innerRef,
            compact,
            minimal,
            weekdays
        } = this.props;

        return (
            <div
                className={cls('card staffCard', {
                    compact: !!compact,
                    minimal: !!minimal,
                })}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={innerRef}
            >
                {!compact && (
                    <div className="dragIndicator">
                        <FontAwesomeIcon icon={faEllipsisV} />
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </div>
                )}
                <CardBody>
                    <CardTitle className="text-left d-flex flex-row justify-content-between align-items-center">
                        <span className="mr-2 staff-name">
                            {broker.companyName}
                        </span>

                        
                    </CardTitle>
                    <CardFooter>
                        <ButtonGroup className="" size="sm">
                            {weekdays.map((dayDate) => {
                                const day = Weekdays.find(
                                    (x) => x.id === dayDate.getDay(),
                                );
                                return (
                                    <span
                                        key={day.id}
                                        className={cls(
                                            'btn btn-sm btn-outline-secondary scheduledDayIndicator',

                                        )}
                                    >
                                        {day.abbreviationShort}
                                    </span>
                                );
                            })}
                        </ButtonGroup>
                    </CardFooter>
                </CardBody> 
            </div>
        );
    }
}
